import { ValidationError } from '@dte/otw-utils-validation/src/ValidationError';

export function validateDefined<T>(
	name: string,
	value: T | null | undefined,
	errorConstructor: new (message: string) => Error = ValidationError,
): T {
	if (value === null || value === undefined) {
		throw new errorConstructor(`Invalid Value: ${name} must be defined`);
	}
	return value;
}
